export const environment = {
  production: false,
  apiUrl: 'https://tplapi.wiantech.net/api/',
  //  apiUrl: 'http://localhost:4000/api/',

  openCartApiUrl: 'https://shop.tplsport.com/index.php',
  ageDiff: 5,
  defaultDate: "february 01 1995 00:00",
  minYear: "1950",
  yearRange: "2023:2060",
  yearDiff: 1,
  pagination: [10, 20, 50, 100, 1000, { showAll: 'All' }],
  productUploadUrl: 'https://tplapi.wiantech.net/uploads/',
  //productUploadUrl: 'http://localhost:4000/uploads/',
  uploadUrl: 'src/public/uploads/cmsPic/',
  imageSize: 50000000,
  videoSize: 50000000,
  defaultDays: 5,
  passEndDate: '2024-12-08',
  frontEnd: {
    domain: 'http://tpl.wiantech.net',
    picPath: 'https://tplapi.wiantech.net'

    // domain: 'http://localhost:4200',
    // picPath: 'http://localhost:4200'

  },
  picture: {
    profilePicFolder: 'src/public/uploads/profilepic/',
    showPicFolderPath: 'uploads/profilepic/',
    defaultPicFolderPath: 'images/',
    bannerImageFolder: 'src/public/uploads/bannerimage/',
    showBannerPicFolderPath: 'uploads/bannerimage/',
    sponsorsPath: 'src/public/uploads/sponsors/',
    highlightpicPath: 'src/public/uploads/highlightpic/',
  },
  api: {
    port: 3008,
    root: '/api',
  },
  tags: [
    { slug: 'hot_seller', name: 'Hot seller', status: false },
    { slug: 'new_arrival', name: 'New arrival', status: false },
    { slug: 'super_deal', name: 'Super deal', status: false },
  ],

  userCategories: [
    { 'value': 'player', slug: 'player', name: 'Player', status: true },
    { 'value': 'coach', slug: 'coach', name: 'Coach', status: false },
    { 'value': 'proplayer', slug: 'proplayer', name: 'Pro player', status: false },
    { 'value': 'user', slug: 'user', name: 'User', status: false },

  ],

  userCategoryType: [
    { 'value': 'player', slug: 'player', name: 'Player', status: true },
    { 'value': 'coach', slug: 'coach', name: 'Coach', status: false },
    { 'value': 'proplayer', slug: 'proplayer', name: 'Pro player', status: false },
    { 'value': 'user', slug: 'user', name: 'User', status: false },

  ],

  roleFilteredArray: [
    'admin',
    'academy',
    'bye',
    'user',
    'guest',
    'superadmin'
  ],
  totalCourtsList: [
    { 'label': '1', 'value': '1' },
    { 'label': '2', 'value': '2' },
    { 'label': '3', 'value': '3' },
    { 'label': '4', 'value': '4' },
    { 'label': '5', 'value': '5' },
    { 'label': '6', 'value': '6' },
    { 'label': '7', 'value': '7' },
    { 'label': '8', 'value': '8' },
    { 'label': '9', 'value': '9' },
    { 'label': '10', 'value': '10' },
    { 'label': 'More', 'value': 'more' },
  ],
  courtTypeList: [
    { 'label': 'Hard / Synthetic', 'value': 'hard_synthetic' },
    { 'label': 'Grass', 'value': 'grass' },
    { 'label': 'Clay', 'value': 'clay' },
  ],
  totalCoachesList: [
    { 'label': 1, 'value': 1 },
    { 'label': 2, 'value': 2 },
    { 'label': 3, 'value': 3 },
    { 'label': 4, 'value': 4 },
    { 'label': 5, 'value': 5 },
    { 'label': 6, 'value': 6 },
    { 'label': 7, 'value': 7 },
    { 'label': 8, 'value': 8 },
    { 'label': 9, 'value': 9 },
    { 'label': 10, 'value': 10 },
    { 'label': 'More', 'value': 'more' },
  ],
  preferredWayList: [
    { 'name': 'Email', 'value': 'email', 'slug': 'emailRadio', 'status': false },
    { 'name': 'Phone Number', 'value': 'phone_number', 'slug': 'phoneRadio', 'status': false },
    { 'name': 'Any', 'value': 'any', 'slug': 'anyRadio', 'status': false }
  ],
  membershipTypeList: [
    { 'name': 'Premium', 'price': '18000', 'currency': '₹', 'value': 'premium', 'status': false, 'amount': 18000, duration: 12 },
    { 'name': 'Standard', 'price': '7500', 'currency': '₹', 'value': 'standard', 'status': false, 'amount': 7500, duration: 12 },
    { 'name': 'Free', 'price': '0', 'currency': '₹', 'value': 'free', 'status': false, 'amount': 0, duration: 12 },
    // { 'name': 'standard': 'free', 'status': false, 'amount': 0, duration: 4 },
  ],
  geoJsonApi: "https://get.geojs.io/v1/ip/geo.json",
  bannedStateList: ["Assam", "Andhra Pradesh", 'Odisha', 'Telangana', "Nagaland", "Sikkim"],
  RAZORPAY_KEY_ID: "rzp_test_lQoczJ5HdCZy9D",
  RAZORPAY_KEY_SECRET: "GZeYEytNSMPlOOhDNJHhh2mj",
  questionTypeList: [
    { 'name': 'Fill in the blank', 'value': 'fillintheblanks', 'status': false },
    { 'name': 'Multiple Choice Question', 'value': 'mcq', 'status': false },
  ],
  EncryptKey: '1203199320052023',
  EncryptIV: '1203199320052023',
  matchTypes: [
    { id: '1', name: 'Single', value: 'single' },
    { id: '2', name: 'Double', value: 'double' },
  ],
  recurringArray: [
    { id: '1', name: 'Today', value: 'today', slug: 'today', status: false },
    { id: '2', name: 'Tomorrow', value: 'tomorrow', slug: 'tomorrow', status: false },
    { id: '3', name: 'Every Week', value: 'every_week', slug: 'every_week', status: false },
    { id: '4', name: 'Every Month', value: 'every_month', slug: 'every_month', status: false },
    { id: '5', name: 'Daily', value: 'daily', slug: 'daily', status: false },
  ],
  amenitiesArray: [
    { id: '1', name: 'Ball', value: 'ball', slug: 'ball', img: 'assets/img/schedule-icon/tennis-ball-svgrepo-com.svg', status: false },
    { id: '2', name: 'Court', value: 'court', slug: 'court', img: 'assets/img/schedule-icon/tennis-court-svgrepo-com.svg', status: false },
    { id: '3', name: 'Tennis Racket', value: 'tennis_racket', slug: 'tennis_racket', img: 'assets/img/schedule-icon/tennis-racket-svgrepo-com.svg', status: false },
  ],
  categorylist: [
    { 'label': "Junior Boy's Singles", 'value': 'junior_boys_singles' },
    { 'label': "Junior Boy's Doubles", 'value': 'junior_boys_doubles' },
    { 'label': "Junior Girl's Singles", 'value': 'junior_girls_singles' },
    { 'label': "Junior Girl's Doubles", 'value': 'junior_girls_doubles' },
    { 'label': "Men's Singles", 'value': 'men_singles' },
    { 'label': "Women's Singles", 'value': 'women_singles' },
    { 'label': "Women's Doubles", 'value': 'women_doubles' },
    { 'label': "Mixed Doubles", 'value': 'mixed_doubles' },
  ],
  agegrouplist: [
    { 'label': 'Under 10', 'value': 'under_10' },
    { 'label': 'Under 12', 'value': 'under_12' },
    { 'label': 'Under 14', 'value': 'under_14' },
    { 'label': 'Under 16', 'value': 'under_16' },
    { 'label': 'Under 18', 'value': 'under_18' },
    { 'label': 'Open', 'value': 'open' },
    { 'label': '35+', 'value': '35+' },
    { 'label': '40+', 'value': '40+' },
    { 'label': '45+', 'value': '45+' },
    { 'label': '50+', 'value': '50+' },
    { 'label': '55+', 'value': '55+' },
    { 'label': '60+', 'value': '60+' },
  ],
  TournamentRankingLevel: [
    { 'label': 'TPL 250 Point', 'value': 'TPL 250 Point' },

  ],

  comingSoonMsg: "Exciting developments are on the horizon! Keep an eye out for an impending announcement that will have you excited and anticipating what's to come. We can't wait to tell you about this fantastic news. Keep a look out for additional updates, because something fantastic is on the way!",
  roundArray: [1, 2, 3, 4, 5, 6, 7],
  yearRangeForChart: 100,
  TDs: 0.30,
  cashContestEntryFee: 10,
  cashEntryFee: 10,
  coinContestEntryFee: 10,
  cashMinimumPrizepool: 100,
  contestCashMinimumPrizepool: 100,
  coinMinimumPrizepool: 100,
  rating: [1, 2, 3, 4, 5],
  sandBoxApiKey: 'key_live_Lcf92IoSojx3bxoqhYLG8xMoNqwBTCUL',
  sandBoxApiSecret: 'secret_live_nYErQnvAaUx3H0PGs3bZZie9M5H1RH0L',
  sandboxUrl: 'https://api.sandbox.co.in',
  contestMatchStatusArray: [
    { label: 'Active', value: 'notstarted' },
    { label: 'Live', value: 'inprogress' },
    { label: 'Close', value: 'finished' },
    { label: 'Cancelled', value: "canceled" },
  ],
  months: [
    { label: 'January', value: 1 },
    { label: 'February', value: 2 },
    { label: 'March', value: 3 },
    { label: 'April', value: 4 },
    { label: 'May', value: 5 },
    { label: 'June', value: 6 },
    { label: 'July', value: 7 },
    { label: 'August', value: 8 },
    { label: 'September', value: 9 },
    { label: 'October', value: 10 },
    { label: 'November', value: 11 },
    { label: 'December', value: 12 }
  ],
  weeks: [
    { label: 'Monday', value: 'monday' },
    { label: 'Tuesday', value: 'tuesday' },
    { label: 'Wednesday', value: 'wednesday' },
    { label: 'Thursday', value: 'thursday' },
    { label: 'Friday', value: 'friday' },
    { label: 'Saturday', value: 'saturday' },
    { label: 'Sunday', value: 'sunday' }
  ],
  times: ['Morning', 'Afternoon', 'Evening', 'Night'],
  openCartUserName: 'Default',
  openCartApiKey: 'ActxFboNyp4BsmiPpqf81gSY6c7OoxVHZwNJm3SpiKwdjUUauSHOJ3f3sBsSZoF5Vt6i7TgZAII28PjlVDF6zEGBRMJodJ5vfk1cDlbSPIME7VRScsy4Mia6zWoHOB5DdFWnVfSBkxxqelj4IQQ6f806s7DOsF2ILWTmplFsJ4lP50tsYd1ZhNjDreiseWCgMwcOgQl4JhB5UfzjMSRdukUAZTb8XPNTn4TqWamdkcsFhUzzFCZ25GhaldzOefDm',
  cancellationPolicyHours: [
    { label: 24, value: 24 },
    { label: 48, value: 48 },
    { label: 72, value: 72 },
    { label: 96, value: 96 },
    { label: 120, value: 120 }
  ],
  groups: [
    { label: '2 Groups', value: 2 },
    { label: '4 Groups', value: 4 },
    { label: '8 Groups', value: 8 }
  ],
  qualifiers: [
    { label: '1 Qualifier', value: 1 },
    { label: '2 Qualifiers', value: 2 }
  ],
  playerPerformancePoints: [
    { label: 1, value: 1, clicked: false },
    { label: 2, value: 2, clicked: false },
    { label: 3, value: 3, clicked: false },
    { label: 4, value: 4, clicked: false },
    { label: 5, value: 5, clicked: false },
    { label: 6, value: 6, clicked: false },
    { label: 7, value: 7, clicked: false },
    { label: 8, value: 8, clicked: false },
    { label: 9, value: 9, clicked: false },
    { label: 10, value: 10, clicked: false }
  ]
};


/*
 * by miDuration value represent year,month,day,hour,min,Second,millisecond
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.